<template>
  <group-card title="Landlord Details" icon="person_pin" :tooltipText="tooltipText">
    <template v-slot:actions v-if="index > 0">
      <md-checkbox v-model="landloard_details" @change="copyFromApplicant1()">Same as applicant 1</md-checkbox>
    </template>
    <div class="boxed-category">
      <md-subheader>Contact</md-subheader>
      <div class="md-layout">
        <!-- Name -->
        <search-text-input
          class="md-layout-item md-small-size-100 md-size-80"
          label="Landlord or Agency Name"
          :prefixLabel="prefixLabel"
          icon="search"
          :searcher="performSearch"
          v-model="applicant.addresses.current.landlord.name"
          @select="selectLandlord"
        >
          <template v-slot="{ item }">
            {{ item.name }}
          </template>
        </search-text-input>

        <!-- Phone -->
        <validated-text-input
          class="md-layout-item md-small-size-100 md-size-20"
          label="Phone Number"
          v-model="applicant.addresses.current.landlord.phone_number"
          :prefixLabel="prefixLabel"
          prefix="+"
          :minLength=7
          :maxLength=15
          errormsg="Please enter a valid phone number, format can contain 7 to 15 digits"
        />
      </div>
    </div>
    <div class="boxed-category">
      <md-subheader>Address</md-subheader>
      <edit-applicant-address
        v-model="applicant.addresses.current.landlord.address"
        :prefixLabel="prefixLabel"
      />
    </div>
  </group-card>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from '@/components/utils/utils';
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import EditApplicantAddress from "./EditApplicantAddress.vue";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    EditApplicantAddress,
  },
  data() {
    return {
      landloard_details: false,
      tooltipText: '<li>Renting - Collect Real Estate house is being rented through and place all details</li>'+
                    '<li>Boarding - Collect Full name and contact number of the person whose name is on the house or lease</li>',
    }
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async performSearch(query){
      const queryType = utils.checkBussinessQueryType(query);
      let params = { [queryType] : query };
      if (this.value.addresses.current.landlord.address.post_code && queryType == 'name') {
        params.postcode = this.value.addresses.current.landlord.address.post_code;
      }

      let response = await axios.get(`/api/v1/sensis/business_by_${queryType}/search`, { params, maxRedirects:0 });
      return response.data;
    },
    selectLandlord(result) {
      this.value.addresses.current.landlord.name = result.name;
    },
    async copyFromApplicant1() {
      if (this.landloard_details) {
        await this.$store.dispatch('copyFromApplicant1', { type: 'landloard_details', applicant_index: this.index });
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>
